export default function (state = {
    isFetching: true
}, action) {
    let isFetching = true;
    switch (action.type) {
        case "MEMBER_GET_REBATE_ESTIMATES_CARDS_DATA_FOR_BHVERIFIED_DATA_TAB":
             //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, rebateEstimatesCardsData: action.payload, isFetching }
        case "MEMBER_PURCHASE_WITHIN_IMARK":
                //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, MemberPurchaseWithinImarkValue: action.payload, isFetching }
        case "MEMBER_PURCHASE_OUTSIDE_IMARK":
                    //console.log('reducer called ', action.payload);
                    isFetching = false;
                    return { ...state, MemberPurchaseOutsideImarkValue: action.payload, isFetching }
        case "MEMBER_OUTSIDE_PURCHASE_BY_CATEGORY":
                    //console.log('reducer called ', action.payload);
                    isFetching = false;
                    return { ...state, MemberOutsidePurchaseByCategory: action.payload, isFetching }
        case "MEMBER_GET_VERIFIED_REBATE_TRENDS_GRAPH":
                        //console.log('reducer called ', action.payload);
                        isFetching = false;
                        return { ...state, getVerifiedRebateTrendsGraph: action.payload, isFetching }
        case "MEMBER_GET_TVPO_TVP_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, tvpoVPNames: action.payload, isFetching }
        case "MEMBER_GET_INVOICES_VP_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, invoiceVPNames: action.payload, isFetching }
        case "MEMBER_VENDOR_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getMemberVendorNames: action.payload, isFetching }
        case "MEMBER_GET_PO_VP_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, poVPNames: action.payload, isFetching }
        case "MEMBER_GET_OVERVIEW_VP_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, overviewVPNames: action.payload, isFetching }
        case "MEMBER_GET_OVERVIEW_PROGRAM_TYPES_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, overviewProgramTypeNames: action.payload, isFetching }
        case "MEMBER_GET_OVERVIEW_SOURCE_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, overviewSourceNames: action.payload, isFetching }
        case "MEMBER_GET_VP_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, vpNames: action.payload, isFetching }
        case "MEMBER_GET_UNAPPROVED_SUPPLIERS_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, unapprovedSuppliersNames: action.payload, isFetching }
        case "MEMBER_GET_CATEGORIES_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, categoriesNames: action.payload, isFetching }
        case "MEMBER_GET_REBATE_NAMES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, rebateNames: action.payload, isFetching }
        case "MEMBER_GET_PURCHASED_ORDERS":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, memberPurchasedOrders: action.payload, isFetching }
        case "MEMBER_GET_REBATE_ESTIMATED_CARDS":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, memberEstimatedCards: action.payload, isFetching }
        case "MEMBER_GET_UNAPPROVED_SUPPLIERS":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, memberUnapprovedSuppliers: action.payload, isFetching }
        case "MEMBER_GET_VENDOR_PARTNER_PURCHASES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, memberVendorPartnerPurchases: action.payload, isFetching }
        case "MEMBER_GET_UNAPPROVED_SUPPLIERS_BY_CATEGORY_DATA":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, memberUnapprovedSuppliersByCategoryData: action.payload, isFetching }
        case "MEMBER_GET_BH_VERIFIED_VENDOR_PARTNER_PURCHASES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getbHverifiedVendorPartnerPurchases: action.payload, isFetching }
        case "VENDOR_FULL_INFO":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getVendorFullInfo: action.payload, isFetching }
        case "VENDOR_OUTSIDE_PURCHASE_PRODUCT_CATEGORY_LIST":
                //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getOutsidePurchaseProductCategory: action.payload, isFetching }
        case "VENDOR_GET_TERMINATED_VP_NAMES_MEMBER":
                    //console.log('reducer called ', action.payload);
                    isFetching = false;
                    return { ...state, getTerminatedVPNamesForMember: action.payload, isFetching }
        case "MEMBER_GET_INVOICE_DATA":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getInvoiceData: action.payload, isFetching }
        case "MEMBER_GET_TERMINATED_VP_OPPORTUNITIES_DETAILS":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getTerminatedVpOpportunitiesTerminatedVpOpportunityDetails: action.payload, isFetching }
        case "MEMBER_GET_TERMINATED_VP_OPPORTUNITIES":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getTerminatedVpOpportunitiesTerminatedVpOpportunity: action.payload, isFetching }
        case "MEMBER_GET_CARDS_DATA_FOR_MEMBER_DATA_TAB":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getCardsDataForMemberDataTab: action.payload, isFetching }
        case "MEMBER_GET_CARDS_DATA_FOR_IMARKVERIFIED_DATA_TAB":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getCardsDataForIMARKVerifiedDataTab: action.payload, isFetching }
        case "MEMBER_GET_CHARTS_DATA_PURCHASE_VS_REBATE_EARNED":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getChartsDataPurchaseVsRebateEarned: action.payload, isFetching }
        case "MEMBER_GET_CHARTS_DATA_REBATE_EARNED_VS_REBATE_RECEIVED":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getChartsDataRebateEarnedVsRebateReceived: action.payload, isFetching }
        case "MEMBER_FAVORABLE_SUPPLIER_FEEDBACK":
            //console.log('reducer called ', action.payload);
            isFetching = false;
            return { ...state, getMemberDataUnapprovedSupplierPurhcaseByCategoryPopUp: action.payload, isFetching }
        case "MEMBER_GET_REBATE_DATA":
            console.log('reducer called for rebates ', action.payload);
            isFetching = false;
            return { ...state, getRebateViewData: action.payload, isFetching }
        case "MEMBER_PRODUCT_CATEGPRY":
                //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getProductCategory: action.payload, isFetching }
        case "MEMBER_INVOICES_BRANCH":
                //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getMemberInvoicesBranchData: action.payload, isFetching }
        case "MEMBER_FBI_REBATE":
                //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getFbiRebateMember: action.payload, isFetching }
        case "MEMBER_FBI_ELIGIBLE_CHECK":
                //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getFbiRebateEligibleCheck: action.payload, isFetching }
        case "MEMBER_BRANCH":
                //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getMemberBranch: action.payload, isFetching }
        case "MEMBER_QUALIFICATION":
                    //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getmemberQualification: action.payload, isFetching }
        case "MEMBER_MONTHS_FILTER":
                    //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getMemberMonthsFilter: action.payload, isFetching }
        case "MEMBER_CONVERSION_MONTHS_FILTER":
                    //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getMemberConversionMonthsFilter: action.payload, isFetching }
        case "MEMBER_VERIFIED_MONTHS_FILTER":
                    //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getMemberVerifiedMonthsFilter: action.payload, isFetching }
        case "VENDOR_GET_LPG_NAMES_MEMBER":
                    //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getLPGNamesForMember: action.payload, isFetching }
        case "MEMBER_QUALIFICATION_STATUS":
                    //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getmemberQualification2021: action.payload, isFetching }
        case "MEMBER_QUALIFICATION_PURCHASES":
                    //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getmemberPurchases: action.payload, isFetching }
                    
        case "MEMBER_PURCHASE_ORDER_EXCEL":
                    //console.log('reducer called ', action.payload);
                isFetching = false;
                return { ...state, getPurchaseOrderExcel: action.payload, isFetching }
           

        default:
            return state;
    }
}